import {
    DOCUMENTBYPROCESS_LIST,
    DOCUMENTBYPROCESS_LIST_SUCCESS,
    DOCUMENTBYPROCESS_LIST_ERROR,
    DOCUMENTBYPROCESS_DDLIST,
    DOCUMENTBYPROCESS_DDLIST_SUCCESS,
    DOCUMENTBYPROCESS_DDLIST_ERROR,
    DOCUMENTBYPROCESS_GET,
    DOCUMENTBYPROCESS_GET_SUCCESS,
    DOCUMENTBYPROCESS_GET_ERROR,
    DOCUMENTBYPROCESS_NEW,
    DOCUMENTBYPROCESS_NEW_SUCCESS,
    DOCUMENTBYPROCESS_NEW_ERROR,
    DOCUMENTBYPROCESS_NEW_RECORD,
    DOCUMENTBYPROCESS_EDIT,
    DOCUMENTBYPROCESS_EDIT_SUCCESS,
    DOCUMENTBYPROCESS_EDIT_ERROR
} from '../types';

const initialState = {
    documentbyprocesses: [], 
    documentbyprocess:{},   
    loading: false,
    error: false
}

export default function(state = initialState, action){
    switch(action.type){
        case DOCUMENTBYPROCESS_LIST:
            return {
                ...state,
                loading: true,
                documentbyprocess: {}
            }
        case DOCUMENTBYPROCESS_LIST_SUCCESS:
            return {
                ...state,
                documentbyprocesses: action.payload,
                loading: false,
                error: false,
                documentbyprocess: {}
            }
        case DOCUMENTBYPROCESS_LIST_ERROR:
            return {
                ...state,
                documentbyprocesses: [],
                loading: false,
                error: true,
                documentbyprocess: {}
            }
        case DOCUMENTBYPROCESS_DDLIST:
            return {
                ...state,
                loading: true,
                documentbyprocess: {}
            }
        case DOCUMENTBYPROCESS_DDLIST_SUCCESS:
            return {
                ...state,
                documentbyprocesses: action.payload,
                loading: false,
                error: false,
                documentbyprocess: {}
            }
        case DOCUMENTBYPROCESS_DDLIST_ERROR:
            return {
                ...state,
                documentbyprocesses: [],
                loading: false,
                error: true,
                documentbyprocess: {}
            }
        case DOCUMENTBYPROCESS_GET:
            return {
                ...state,
                loading: true
            }
        case DOCUMENTBYPROCESS_GET_SUCCESS:
            return {
                ...state,
                documentbyprocess: action.payload,
                loading: false,
                error: false
            }
        case DOCUMENTBYPROCESS_GET_ERROR:
            return {
                ...state,
                error: true,
                documentbyprocess: {}
            }
        case DOCUMENTBYPROCESS_NEW:
            return {
                ...state
            }
        case DOCUMENTBYPROCESS_NEW_SUCCESS:
            return {
                ...state,
                documentbyprocesses: [...state.documentbyprocesses, action.payload],
                documentbyprocess: {},
                error: false
            }
        case DOCUMENTBYPROCESS_NEW_ERROR:
            return {
                ...state,
                error: true
            }
        case DOCUMENTBYPROCESS_NEW_RECORD:
            return {
                ...state,
                documentbyprocess: {},
                error: false
            }
        case DOCUMENTBYPROCESS_EDIT:
            return {
                ...state
            }
        case DOCUMENTBYPROCESS_EDIT_SUCCESS:
            return {
                ...state,
                error: false,
                documentbyprocess: action.payload,
                documentbyprocesses: state.documentbyprocesses.map(documentbyprocess => documentbyprocess.id === action.payload.id ? documentbyprocess = action.payload : documentbyprocess),
            }
        case DOCUMENTBYPROCESS_EDIT_ERROR:
            return {
                ...state,
                error: false
            }
        default:
            return state;
    }
}
